import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAuth } from 'hooks'
import { getRemainingTime } from 'utils/helpers'
import { refresh } from 'features/auth/authSlice'

export const useRefreshToken = () => {
    const dispatch = useDispatch()
    const { expireOn } = useAuth()

    useEffect(() => {
        let timer = null
        if (expireOn) {
            const remainingTime = getRemainingTime(expireOn) - 300

            if (remainingTime > 0) {
                timer = setTimeout(() => {
                    dispatch(refresh())
                }, 1000 * remainingTime)
            } else {
                dispatch(refresh())
            }
        } else {
            clearTimeout(timer)
        }

        return () => clearTimeout(timer)
    }, [expireOn])
}
